<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Asset Request Summary</h4>
    <button
      type="button"
      class="btn-close"
      data-dismiss="modal"
      tabindex="-1"
      (click)="reset()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid p-0">
      <!-- <button type="button" class="btn btn-warning" (click)="processContraAndDistribute()">Distribute</button> -->

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <td>Type:</td>
                    <td>{{ type }}</td>
                  </tr>
                  @if (amount != undefined && amount > 0) {
                    <tr>
                      <td>Amount:</td>
                      <td>RM {{ amount | number: "1.2-2" }}</td>
                    </tr>
                  }

                  <tr>
                    <td>Reason/Remark:</td>
                    <td>{{ reason }}</td>
                  </tr>
                  @if (selectedCustomer != undefined) {
                    <tr>
                      <td>Customer:</td>
                      <td>
                        {{ selectedCustomer.Name }} ({{
                          selectedCustomer.ICNumber
                        }})
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="col-2">
              <div class="d-flex justify-content-end align-items-end">
                <button
                  class="btn btn-light"
                  (click)="isDistributionCollapse = !isDistributionCollapse"
                  [attr.aria-expanded]="!isDistributionCollapse"
                  aria-controls="distributionCollapse"
                >
                  @if (isDistributionCollapse) {
                    <i class="fas fa-chevron-circle-down"></i>
                  }
                  @if (isDistributionCollapse == false) {
                    <i class="fas fa-chevron-circle-up"></i>
                  }
                </button>
              </div>
            </div>
          </div>

          <div
            class="collapse"
            id="distributionCollapse"
            [ngbCollapse]="isDistributionCollapse"
          >
            @if (kerjaContraList.length > 0) {
              <hr />
              <h3>After Deducting Kerja</h3>

              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th>Branch</th>
                    <th>Apply Amount(RM)</th>
                    <th>Return Amount(RM)</th>
                  </tr>

                  @for (
                    branch of kerjaContraList;
                    track branch;
                    let i = $index
                  ) {
                    <tr>
                      <td>
                        <span>{{ branch.appliedBranch.CompanyCode }}</span>
                      </td>
                      <td>
                        @if (branch.overflow == 0) {
                          <b class="d-block">
                            Total: RM
                            {{
                              branch.remainingAmount + branch.carryAmount
                                | number: "1.2-2"
                            }}</b
                          >
                          <span class="d-block"
                            >Contra Apply: RM
                            {{ branch.carryAmount | number: "1.2-2" }}</span
                          >
                          <span class="d-block">
                            Bank in: RM
                            {{ branch.remainingAmount | number: "1.2-2" }}</span
                          >
                        }
                      </td>
                      <td>
                        @if (branch.overflow > 0) {
                          <span
                            >RM {{ branch.overflow | number: "1.2-2" }}</span
                          >
                        }
                      </td>
                    </tr>
                  }
                </tbody>
                <tfoot></tfoot>
              </table>
            } @else if (
              contraApplyBranches.length > 0 && contraReturnBranches.length > 0
            ) {
              <hr />
              <h3>Contra Summary</h3>
              <div class="row">
                <div class="col-6">
                  <b>Apply</b>
                  @for (ca of contraApplyBranches; track ca) {
                    <p>
                      {{ ca.appliedBranch.CompanyCode }} = RM
                      {{ ca.amount | number: "1.2-2" }}
                    </p>
                  }
                </div>
                <div class="col-6">
                  <b>Return</b>
                  @for (cr of contraReturnBranches; track ca) {
                    <p>
                      {{ cr.appliedBranch.CompanyCode }} = RM
                      {{ cr.amount | number: "1.2-2" }}
                    </p>
                  }
                </div>
              </div>
            }

            @if (finalDistribution.length > 0) {
              <hr />
              <h3>Bank In Distribution</h3>
              <table class="table">
                <thead>
                  <tr>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Distribution</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of finalDistribution; track $index) {
                    <tr>
                      <td>
                        {{ item.bank.HolderName }} ({{ item.bank.Bank }} -{{
                          item.bank.AccountNumber
                        }}
                        )
                      </td>
                      <td>RM {{ item.total | number: "1.2-2" }}</td>
                      <td>
                        <table class="table table-bordered">
                          <tbody>
                            @for (d of item.distributed; track $index) {
                              <tr>
                                <td>{{ d.branch.CompanyCode }}</td>
                                <td>RM {{ d.amount | number: "1.2-2" }}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-outline-success"
      type="button"
      (click)="sendRequestAndShowMessage()"
      [disabled]="disabledSubmit"
    >
      Submit
    </button>
    <button class="btn btn-outline-danger" type="button" (click)="reset()">
      Cancel
    </button>
  </div>
</form>
